import { defineComponent as _defineComponent } from 'vue';
import { useFrameStore } from './seg-frame-store';
import { THEME } from './helpers/frameConstants';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BatchCollectionTray',
    setup(__props, { expose: __expose }) {
        __expose();
        const store = useFrameStore();
        /**
         * Handles the "Stash" action.
         */
        const handleAddToBatch = () => {
            store.stashCurrentFrame();
        };
        /**
         * Removes a specific frame from the collection.
         */
        const handleRemove = (id) => {
            store.removeFrame(id);
        };
        const __returned__ = { store, handleAddToBatch, handleRemove, get THEME() { return THEME; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
